/**
 * FloraHut Theme - Modern Search Drawer & Dropdown JavaScript
 * File: assets/search-drawer.js
 * Plain Vanilla JS, Ultra-Fast, Modular
 */

(function () {
  'use strict';

  function initSearchDrawer() {
    var drawer = document.getElementById('SearchDrawerModal');
    if (!drawer) return;

    // Break drawer out of header stacking context and mount directly into body
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    var input = drawer.querySelector('.sd-input');
    var clearBtn = drawer.querySelector('.sd-clear-btn');
    var closeButtons = drawer.querySelectorAll('.sd-back-btn, .sd-close-desktop, .closeSearch');
    var searchPre = drawer.querySelector('#sdSearchPre');
    var searchList = drawer.querySelector('#sdSearchList');
    var debounceTimer = null;

    // 1. Close Drawer Handlers
    function closeDrawer() {
      document.documentElement.classList.remove('searchact', 'showOverly', 'stopScroll');
      document.body.classList.remove('searchact', 'stopScroll');
      var overly = document.querySelector('.modalOverly');
      if (overly) overly.style.display = 'none';
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    });

    // Close on backdrop click (Desktop modal outside click)
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) {
        closeDrawer();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (document.documentElement.classList.contains('searchact')) {
          closeDrawer();
        }
        var desktopRes = document.querySelectorAll('.main-search .s_res, .searchinline .s_res');
        desktopRes.forEach(function (res) {
          res.style.display = 'none';
        });
      }
    });

    // 2. Clear Button Handler
    if (clearBtn && input) {
      clearBtn.addEventListener('click', function (e) {
        e.preventDefault();
        input.value = '';
        clearBtn.style.display = 'none';
        if (searchList) {
          searchList.innerHTML = '';
          searchList.style.display = 'none';
        }
        if (searchPre) {
          searchPre.style.display = 'block';
        }
        input.focus();
      });
    }

    // 3. Trending Searches Pill Click Handler (Drawer & Desktop Dropdown)
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.sd-pill');
      if (!pill) return;
      e.preventDefault();
      var query = pill.getAttribute('data-query') || pill.textContent.trim();
      if (!query) return;

      var desktopForm = pill.closest('form.search');
      if (desktopForm) {
        var desktopInput = desktopForm.querySelector('input[name="q"]');
        if (desktopInput) {
          desktopInput.value = query;
          // Trigger keyup/input to fetch predictive results
          var event = new Event('keyup', { bubbles: true });
          desktopInput.dispatchEvent(event);
          desktopInput.focus();
        }
      } else if (input) {
        input.value = query;
        if (clearBtn) clearBtn.style.display = 'inline-flex';
        performSearch(query);
        input.focus();
      }
    });

    // 4. Live Predictive Search Handler (Debounced)
    if (input) {
      input.addEventListener('input', function () {
        var query = this.value.trim();

        if (clearBtn) {
          clearBtn.style.display = query.length > 0 ? 'inline-flex' : 'none';
        }

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          if (query.length >= 2) {
            performSearch(query);
          } else {
            if (searchList) {
              searchList.innerHTML = '';
              searchList.style.display = 'none';
            }
            if (searchPre) {
              searchPre.style.display = 'block';
            }
          }
        }, 220);
      });
    }

    // Predictive Search Fetch
    async function performSearch(query) {
      if (!query || !searchList) return;

      var baseUrl = window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest';
      var searchUrl = baseUrl + '?q=' + encodeURIComponent(query) + '&section_id=predictive-search';

      try {
        var res = await fetch(searchUrl);
        if (!res.ok) throw new Error('Search failed');
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search') || doc.body;

        if (section) {
          searchList.innerHTML = section.innerHTML;
          searchList.style.display = 'block';
          if (searchPre) searchPre.style.display = 'none';
        }
      } catch (err) {
        console.warn('Predictive search error:', err);
      }
    }

    // 5. Instant 1-Click Quick Add to Cart for Best Sellers (Drawer & Desktop)
    document.addEventListener('click', async function (e) {
      var atcBtn = e.target.closest('.sd-atc-btn');
      if (!atcBtn || atcBtn.classList.contains('is-loading')) return;

      var variantId = atcBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      atcBtn.classList.add('is-loading');
      var originalText = atcBtn.innerHTML;
      atcBtn.innerHTML = '';

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (res.ok) {
          atcBtn.classList.remove('is-loading');
          atcBtn.classList.add('is-added');
          atcBtn.innerHTML = 'ADDED &#10003;';

          // Update global cart badges across the store
          try {
            var cartRes = await fetch('/cart.js');
            var cart = await cartRes.json();
            document.querySelectorAll('[data-cart-render="item_count"], #cart-icon-bubble, .mbtl-cart-badge').forEach(function (el) {
              el.textContent = cart.item_count;
              if (el.classList.contains('mbtl-cart-badge')) {
                el.setAttribute('data-count', cart.item_count);
                if (cart.item_count === 0) el.classList.add('hide');
                else el.classList.remove('hide');
              }
            });
          } catch (e) {}

          // Refresh drawer DOM if CartDrawerItems exists
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            var itemData = await res.json().catch(function() { return {}; });
            cartDrawer.renderContents(itemData);
          }

          // Reset button text after 1.5 seconds
          setTimeout(function () {
            atcBtn.classList.remove('is-added');
            atcBtn.innerHTML = originalText;
          }, 1500);

        } else {
          atcBtn.classList.remove('is-loading');
          atcBtn.innerHTML = originalText;
        }
      } catch (err) {
        console.error('Quick Add Error:', err);
        atcBtn.classList.remove('is-loading');
        atcBtn.innerHTML = originalText;
      }
    });

    // 6. Auto-focus input when opened
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class' && document.documentElement.classList.contains('searchact')) {
          setTimeout(function () {
            if (input) input.focus();
          }, 150);
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    // 7. Mouse Wheel & Drag Horizontal Scroll for Best Sellers (.sd-products-scroll)
    document.addEventListener('wheel', function (e) {
      var row = e.target.closest('.sd-products-scroll');
      if (!row) return;

      var maxScroll = row.scrollWidth - row.clientWidth;
      if (maxScroll <= 0) return;

      var delta = Math.abs(e.deltaY) >= Math.abs(e.deltaX) ? e.deltaY : e.deltaX;
      if (delta > 0 && row.scrollLeft < maxScroll - 2) {
        e.preventDefault();
        row.scrollLeft += delta;
      } else if (delta < 0 && row.scrollLeft > 2) {
        e.preventDefault();
        row.scrollLeft += delta;
      }
    }, { passive: false });

    // Mouse click-and-drag horizontal scroll for easy desktop mouse navigation
    var isDragging = false;
    var startX = 0;
    var initialScroll = 0;
    var activeScrollRow = null;
    var hasMoved = false;

    document.addEventListener('mousedown', function (e) {
      var row = e.target.closest('.sd-products-scroll');
      if (!row) return;
      isDragging = true;
      activeScrollRow = row;
      startX = e.pageX - row.offsetLeft;
      initialScroll = row.scrollLeft;
      hasMoved = false;
    });

    document.addEventListener('mousemove', function (e) {
      if (!isDragging || !activeScrollRow) return;
      var currentX = e.pageX - activeScrollRow.offsetLeft;
      var walk = (currentX - startX) * 1.5;
      if (Math.abs(walk) > 5) {
        hasMoved = true;
        activeScrollRow.style.cursor = 'grabbing';
        activeScrollRow.style.userSelect = 'none';
      }
      activeScrollRow.scrollLeft = initialScroll - walk;
    });

    function stopDragging() {
      if (activeScrollRow) {
        activeScrollRow.style.cursor = '';
        activeScrollRow.style.userSelect = '';
      }
      isDragging = false;
      activeScrollRow = null;
    }

    document.addEventListener('mouseup', function () {
      setTimeout(function () {
        hasMoved = false;
      }, 50);
      stopDragging();
    });

    document.addEventListener('mouseleave', stopDragging);

    // Prevent navigation if user dragged
    document.addEventListener('click', function (e) {
      if (hasMoved && e.target.closest('.sd-products-scroll a')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchDrawer);
  } else {
    initSearchDrawer();
  }
})();
